<div class="bg-white">
    <h1 mat-dialog-title *ngIf="settings.title" class="mb-0">
        {{ settings.title }}
    </h1>
    <hr *ngIf="settings.title" class="separator mt-1 mb-1" />
    <div
        *ngIf="!settings.icon"
        mat-dialog-content
        [innerHtml]="settings.body"
    ></div>
    <div *ngIf="settings.icon" mat-dialog-content>
        <div class="flex p-0">
            <div
                class="shrink-0"
                class="w-[2.5rem] h-[2.4rem] md:w-[5rem] md:h-[4.8rem] self-center"
            >
                <mat-icon
                    class="text-warn text-[2.5rem] h-[2.25rem] w-[2.5rem] md:text-[5rem] md:h-[4.5rem] md:w-[5rem]"
                    >{{ settings.icon }}</mat-icon
                >
            </div>
            <div class="flex content-center items-center pl-3 min-h-[70px] max-h-[900px] overflow-y-scroll">
                <p class="text-justify whitespace-pre-wrap" [innerHtml]="settings.body | replaceLineBreaks"></p>
            </div>
        </div>
    </div>
    <div mat-dialog-actions align="end" class="pt-0">
        <button mat-flat-button color="warn" (click)="onAceptar()">
            <mat-icon class="mr-1" svgIcon="heroicons_outline:check-circle"></mat-icon>
            Aceptar
        </button>
    </div>
</div>
